import React from "react";
import { Card } from "../../pages/Theme";


const EditCardStatus = () => {
    return(
        <Card className="flex flex-col px-3 xl:px-20 pt-5 pb-10 mt-6 lg:mt-12 mb-4 
                        h-40 md:w-full items-center rounded-lg "
        >
            <div className="mt-2 w-28 xl:w-44 bg-gray-200 h-4 rounded-md mb-4"></div>
            <div className="mt-2 w-72 md:w-96 xl:w-8/12 bg-gray-200 h-4 rounded-md"></div>
            <div className="mt-2 w-64 md:w-72 xl:w-7/12 bg-gray-200 h-4 rounded-md"></div>
            
        </Card>
    )
}


export default EditCardStatus